<template>
  <div id="app">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
    >
    
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  mounted() {

  }
};
</script>

<style lang="scss">
@import "./styles/animation.css";
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme(
  "default",
  (
    primary: md-get-palette-color(black, A200),
    // The primary color of your application
      accent: md-get-palette-color(red, A200) // The accent or secondary color
  )
);
@import "~vue-material/dist/theme/all"; // Apply the theme
html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
 
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}
</style>
